<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['v-card__actions--group', getSelectedDEV && 'dev-selected-component']">
    <v-btn
      v-for="(action, index) in actions"
      v-bind="[attributes, action.attributes]"
      @click="execute(action)"
      :key="index"
      :disabled="action.readonly"
      :name="action.name"
      :id="action.id"
      :loading="actionName === action.name && loading"
      v-tooltip.bottom="{ content: action.tooltip, classes: action.tooltipColorClass }"
    >
      <v-icon v-if="action.attributesIcon.icon && !action.attributesIcon.right" v-bind="action.attributesIcon" class="mr-1">{{
        action.attributesIcon.icon
      }}</v-icon>
      {{ action.label }}
      <v-icon v-if="action.attributesIcon.icon && action.attributesIcon.right" v-bind="action.attributesIcon" class="ml-1">{{
        action.attributesIcon.icon
      }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import store from '@/store';

import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [devComponentMixin],

  props: {
    actions: { type: Array, required: true },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    step: { type: Number, required: false },
    attributes: { type: Object, default: () => ({}), required: true },
    schema: { type: Object, default: () => ({}) }
  },

  data: () => ({
    loading: false,
    actionName: ''
  }),

  events: {
    [HANDLERS.INIT_LOADING]: 'initLoading',
    [HANDLERS.FINISH_LOADING]: 'finishLoading'
  },

  methods: {
    execute(action) {
      action.mode = this.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.page, step: this.step });
    },

    initLoading(action) {
      this.actionName = action.name;

      const _vm = this;

      this.actions.map(function(item) {
        if (item.name === action.name) {
          _vm.loading = true;

          return;
        }
      });
    },

    finishLoading() {
      this.actionName = '';
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-toolbar__items {
  .v-card__actions--group {
    align-items: center;
    align-self: center;
    height: 100%;
    max-height: 100%;

    .v-btn {
      height: inherit;
    }
  }
}
</style>
